import App from "App";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { ArgonControllerProvider } from "context";

import { initClarity } from "initClarity";

// Silenciar logs de debug en producción (se mantienen warn/error)
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
}

initClarity();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ArgonControllerProvider>
      <App />
    </ArgonControllerProvider>
  </BrowserRouter>
);
